import script from "./SimpleButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./SimpleButton.vue?vue&type=script&lang=ts&setup=true"

import "./SimpleButton.vue?vue&type=style&index=0&id=2d3b9d3a&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d3b9d3a"]])

export default __exports__